import React, {FC} from 'react';
import InlineInputControlRow from "../../ui/layout/InlineInputControlRow";

const Fieldset: FC<{
  label: string,
  noPadding?: boolean,
  noInlinePadding?: boolean,
  horizontal?: boolean,
  noBold?: boolean,
  alignRight?: boolean,
}> = ({
        label,
        noPadding,
        noInlinePadding,
        horizontal,
        noBold,
        children,
        alignRight,
      }) => {

  const fieldset = (
    <div className={`report-fieldset ${noPadding || horizontal ? 'mt-0' : ''}`}>
      {!horizontal && (
        <div className={noBold ? 'report-fieldset-title-no-bold' : 'report-fieldset-title'}>
          {label}
        </div>
      )}
      <div className={`report-fieldset-content ${noInlinePadding ? 'pt-1 pb-0' : ''}`}>
        {children}
      </div>
    </div>
  )

  return horizontal ? (
    <InlineInputControlRow smallMargin alignRight={alignRight??false} label={label} mode='smaller-2x'>
      {fieldset}
    </InlineInputControlRow>
  ) : fieldset;
}

export default Fieldset